var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('textarea',{staticClass:"textarea disp-scroll",attrs:{"placeholder":"MEMO","disabled":_vm.isConfirm},domProps:{"value":_vm.mainmessage.replace('[memo]', '').replace('[/memo]', '')},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b9954b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/chatbot/modals/ModalFusenParts.vue
// module id = null
// module chunks = 